import {
    FETCH_USER_PRODUCTIVITY,
    FETCH_USERS_TYPE_WISE_COUNT,
    FETCH_ALL_CHECKPOINTS_PERMISSIONS
  } from "../types";

const intialState = {
    AllUserData: {},
    AllUserWithoutFilter: {},
    userJobProductivity: {},
    counts :{},
    userTypeWiseCount: null,
    checkpointPermissions:[]
};


const ManageTeamReducer = (state = intialState, { type, payload }) => {
    switch (type) {
        case "GET_ALL_USERS_DATA":
            return { ...state, AllUserData: payload }
        case "GET_ALL_USERS_WITHOUT_FILTER": 
            return { ...state, AllUserWithoutFilter: payload}
        case "GET_COUNTS":
            return { ...state, counts: payload }
        case FETCH_USER_PRODUCTIVITY:
            return { ...state, userJobProductivity: payload }
        case FETCH_USERS_TYPE_WISE_COUNT:
            return { ...state, userTypeWiseCount: payload }
        case FETCH_ALL_CHECKPOINTS_PERMISSIONS:
            return { ...state, checkpointPermissions: payload }
        default:
            return state;
    }
}
export default ManageTeamReducer;